import React, { useState } from 'react';
import { FiInfo } from 'react-icons/fi';

const InfoTooltip = ({
  content,
  position = 'top',
  maxWidth = '300px',
  trigger = 'hover', // 'hover' or 'click'
  className = '', // Add className prop
  style = {}, // Add style prop
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (trigger === 'hover') {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (trigger === 'hover') {
      setIsVisible(false);
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (trigger === 'click') {
      setIsVisible(!isVisible);
    }
  };

  const getTooltipPosition = () => {
    switch (position) {
      case 'top':
        return {
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '8px',
        };
      case 'bottom':
        return {
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginTop: '8px',
        };
      case 'left':
        return {
          right: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginRight: '8px',
        };
      case 'right':
        return {
          left: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginLeft: '8px',
        };
      default:
        return {
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '8px',
        };
    }
  };

  const getArrowStyle = () => {
    const arrowSize = '6px';
    const arrowColor = 'var(--liwaza-surface-container-highest)';

    switch (position) {
      case 'top':
        return {
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: `${arrowSize} solid transparent`,
          borderRight: `${arrowSize} solid transparent`,
          borderTop: `${arrowSize} solid ${arrowColor}`,
        };
      case 'bottom':
        return {
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: `${arrowSize} solid transparent`,
          borderRight: `${arrowSize} solid transparent`,
          borderBottom: `${arrowSize} solid ${arrowColor}`,
        };
      case 'left':
        return {
          position: 'absolute',
          left: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 0,
          height: 0,
          borderTop: `${arrowSize} solid transparent`,
          borderBottom: `${arrowSize} solid transparent`,
          borderLeft: `${arrowSize} solid ${arrowColor}`,
        };
      case 'right':
        return {
          position: 'absolute',
          right: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 0,
          height: 0,
          borderTop: `${arrowSize} solid transparent`,
          borderBottom: `${arrowSize} solid transparent`,
          borderRight: `${arrowSize} solid ${arrowColor}`,
        };
      default:
        return {
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: `${arrowSize} solid transparent`,
          borderRight: `${arrowSize} solid transparent`,
          borderTop: `${arrowSize} solid ${arrowColor}`,
        };
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        cursor: trigger === 'click' ? 'pointer' : 'help',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <FiInfo
        size={16}
        style={{
          color: 'var(--liwaza-primary)',
          opacity: 0.7,
          transition: 'opacity 0.2s ease',
          ...style,
        }}
        onMouseEnter={(e) => {
          e.target.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.target.style.opacity = '0.7';
        }}
      />

      {isVisible && (
        <div
          style={{
            position: 'absolute',
            ...getTooltipPosition(),
            background: 'var(--liwaza-surface-container-highest)',
            color: 'var(--liwaza-on-surface)',
            padding: '12px 16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            border: '1px solid var(--liwaza-outline-variant)',
            fontSize: '0.875rem',
            lineHeight: '1.4',
            maxWidth: maxWidth,
            zIndex: 10000,
            whiteSpace: 'normal',
            textAlign: 'left',
            animation: 'fadeIn 0.2s ease',
            width: maxWidth,
          }}
          className={className}
        >
          {content}
          <div style={getArrowStyle()} />
        </div>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateX(-50%) translateY(-4px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default InfoTooltip;
